import { Entity } from '@beecore/core';

@Entity()
export class SfeAuthResponseEntity {
  /** JWT Access Token. */
  accessToken: string;
  /** JWT Encripted Access Token. */
  encryptedAccessToken: string;
  /** JWT Token expide time in seconds. */
  expireInSeconds: number;
  /** The authenticated user key. */
  userId: number;
  /** If the current user is a Tenant User, then provides the tenant ID */
  tenantId?: number;
}
